import { motion, AnimatePresence } from "framer-motion";
import { Empty } from "antd";
import { useIntl } from "react-intl";
import TasksListItem from "./TasksListItem";
const TasksList = (props) => {
  const { isOpen, items, onEditTask, onRatingChanged, onReload } = props;
  const intl = useIntl();
  const itemVariants = {
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 300, damping: 24 },
    },
    hidden: { opacity: 1, y: 20, transition: { duration: 0.2 } },
  };
  return items && items.length > 0 ? (
    <div className="tasks">
      <AnimatePresence>
        <motion.ul
          variants={{
            open: {
              transition: {
                type: "spring",
                bounce: 0,
                duration: 0.7,
                delayChildren: 0.3,
                staggerChildren: 0.05,
              },
            },
            closed: {
              transition: {
                type: "spring",
                bounce: 0,
                duration: 0.3,
              },
            },
          }}
          style={{ pointerEvents: isOpen ? "auto" : "none" }}
        >
          {items.map((record) => (
            <motion.li
              key={record.id}
              itemKey={record.id}
              variants={itemVariants}
              initial="hidden"
              animate="visible"
            >
              <TasksListItem
                record={record}
                onEditTask={onEditTask}
                onRatingChanged={onRatingChanged}
                onReload={onReload}
              />
            </motion.li>
          ))}
        </motion.ul>
      </AnimatePresence>
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Empty
        imageStyle={{
          height: 60,
        }}
        description={intl.formatMessage({
          id: "app.activities.no_results_description",
        })}
      />
    </div>
  );
};

export default TasksList;
